import api from './api'
import { API_ENDPOINTS } from '../config/api'

const walletService = {
  // Deposit — parent se apne direct child ko points.
  // Body: { userId, amount, userType, remark, transactionPassword }
  addDeposit: async (data) => {
    const response = await api.post(API_ENDPOINTS.WALLET.DEPOSIT_ADD, data)
    return response.data
  },
  // Withdraw — deposit ka ulta (child se points wapas parent me).
  // Same body; server yaha remark ko required maanta hai.
  withdrawChild: async (data) => {
    const response = await api.post(API_ENDPOINTS.WALLET.WITHDRAW, data)
    return response.data
  },
  // Credit (C) — direct child ke wallet me cr set karta hai (naya credit, delta nahi).
  // Body: { userId, username, credit, transactionPassword }
  setCreditLimit: async (data) => {
    const response = await api.post(API_ENDPOINTS.WALLET.SET_CREDIT_LIMIT, data)
    return response.data
  },
  // Settlement — direct child ka pending clear karta hai (points signed hote hain:
  // + = child ko dena, − = child se lena). Body: { userId, username, points,
  // remark, transactionPassword }. Server userId+username dono match karta hai.
  settlePoints: async (data) => {
    const response = await api.post(API_ENDPOINTS.WALLET.POINTS_SETTLE, data)
    return response.data
  },
  // Owner self deposit — owner apne hi wallet me balance daalta hai (inr_balance,
  // credit aur all_point badhte hain). Sirf OWNER role ke liye, server bhi
  // requireOwner se gate karta hai. Body: { amount, remark, transactionPassword }
  ownerSelfDeposit: async (data) => {
    const response = await api.post(API_ENDPOINTS.WALLET.OWNER_SELF_DEPOSIT, data)
    return response.data
  }
}

export default walletService
